var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "420" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "tertiary",
                    attrs: {
                      loading: _vm.loading,
                      large: _vm.large,
                      small: _vm.small,
                      disabled: _vm.disabled,
                      color: _vm.color || "error",
                      outline: "",
                    },
                  },
                  on
                ),
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(_vm._s(_vm.icon || "delete_forever")),
                  ]),
                  _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("v-card-text", [_vm._v(_vm._s(_vm.text))]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: _vm.color || "error" },
                  on: { click: _vm.submit },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v(_vm._s(_vm.icon || "delete_forever")),
                  ]),
                  _vm._v(
                    "\n        " + _vm._s(_vm.confirm || "Remove") + "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { depressed: "" }, on: { click: _vm.close } },
                [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }